import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ProposalClientEditComponent } from '../../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { PurchasesQuoteRequestService } from '../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { PurchasesQuoteRequestCreateComponent } from '../../../features/purchases/purchases-quote-request/purchases-quote-request-create/purchases-quote-request-create.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatTabsModule } from '@angular/material/tabs'
import { ModalPurchasesRequestItinerariesComponent } from '../../../features/purchases/purchases-quote-request/modal-purchases-request-itineraries/modal-purchases-request-itineraries.component'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatOptionModule } from '@angular/material/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { JsonPipe } from '@angular/common'
import { FormSearchQuoteTgComponent } from '../../../shared/components/form-search-quote-tg/form-search-quote-tg.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { TableListPurchasesQuoteSupplierPageComponent } from '../../../shared/components/table-list-purchases-quote-supplier-page/table-list-purchases-quote-supplier-page.component'
import { FormSearchQuoteRequestTgComponent } from '../../../shared/components/form-search-quote-request-tg/form-search-quote-request-tg.component'
import { FormSearchQuoteRequestTgNewComponent } from '../../../shared/components/form-search-quote-request-tg-new/form-search-quote-request-tg-new.component'
import { PurchasesQuoteRequestCreateNewComponent } from '../../../features/purchases/purchases-quote-request/purchases-quote-request-create-new/purchases-quote-request-create-new.component'
import { FormSearchRefusedQuotesComponent } from '../../../shared/components/form-search-refused-quotes/form-search-refused-quotes.component'
import { FormSearchComprasHistoricoComponent } from '../../../shared/components/form-search-compras-historico/form-search-compras-historico.component'
import { ModalComprasHistoricoDetailComponent } from '../../../features/purchases/purchases-quote-request/modal-compras-historico-detail/modal-compras-historico-detail.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { downloadBase64File } from '../../../shared/utils/download_base64'
import {
  durationToSeconds,
  secondsToDuration,
} from '../../../shared/utils/utils'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

// Desfechos em que o Compras de fato respondeu a ida — são os que entram no tempo médio.
// Ficam de fora "Em aberto" (relógio ainda correndo), "Cancelado" (o consultor desistiu) e
// "Regularizado sem Compras" (o consultor resolveu sozinho).
// O VM do histórico devolve só o texto do desfecho, sem o id: a comparação é pelo rótulo que o
// back monta em ComprasHistoricoHelper.DescreverDesfecho.
const DESFECHOS_RESPONDIDOS = ['Precificado', 'Recusado']

@Component({
  selector: 'purchases-quote-request',
  imports: [
    MatProgressBar,
    PaginationComponent,
    MatButton,
    TableListTariffComponent,
    MatPaginatorModule,
    MatTabsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    JsonPipe,
    FormSearchQuoteTgComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListPurchasesQuoteSupplierPageComponent,
    FormSearchQuoteRequestTgComponent,
    FormSearchQuoteRequestTgNewComponent,
    FormSearchRefusedQuotesComponent,
    FormSearchComprasHistoricoComponent,
    MatProgressSpinner,
  ],
  templateUrl: './purchases-quote-request.component.html',
  styleUrl: './purchases-quote-request.component.scss',
  providers: [ProposalClientService, AuthService],
  standalone: true,
})
export class PurchasesQuoteRequestComponent implements OnInit {
  constructor(
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private proposalClientService: ProposalClientService,
    private authService: AuthService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
  ) {}

  form: FormGroup = new FormGroup({})

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  listStatus: any[] = []
  loading = false
  columns: any[] = [
    {
      keyColumn: 'tgcod',
      key: 'tg',
      description: 'tg cod.',
    },
    {
      keyColumn: 'event',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'custumerPurchase',
      key: 'nomeClient',
      description: 'Cliente / Subcliente',
    },
    {
      keyColumn: 'consultant',
      key: 'nomeConsultor',
      description: 'Solicitante',
    },
    {
      keyColumn: 'consultantCommercial',
      key: 'consultorComercial',
      description: 'Consultor Comercial',
    },
    // {
    //   keyColumn: 'event_tgCod',
    //   key: 'tg_info',
    //   description: 'Proposta',
    // },
    // {
    //   keyColumn: 'pageTariffLocation',
    //   // keyColumn: 'location_OD',
    //   key: 'origem',
    //   description: 'Trecho',
    // },
    // {
    //   keyColumn: 'servico_TS',
    //   key: 'tipoServico',
    //   description: 'Serviço',
    // },
    // {
    //   keyColumn: 'vehicle_VM',
    //   key: 'tipoVeiculo',
    //   description: 'Veículo',
    // },
    // {
    //   keyColumn: 'pageDate',
    //   key: 'origem',
    //   description: 'Data',
    // },
    // {
    //   keyColumn: 'status',
    //   key: 'descricaoStatus',
    //   description: 'Status',
    // },
    {
      keyColumn: 'action',
      key: {
        edit: false,
        delete: false,
        download: false,
        select: true,
        sendContract: false,
        sendEmail: false,
        sendItineraries: false,
      },
      description: 'Ações',
    },
  ]

  screen = 'compras'

  // Aba Cotações Recusadas
  pageRefused = 1
  rowsRefused = 10
  numberRowsRefused = 0
  itemsListRefused: any[] = []
  loadingRefused = false
  exportingRefused = false
  refusedLoaded = false
  searchFormRefused: any = { search: false, model: {} }
  columnsRefused: any[] = [
    { keyColumn: 'codigoTg', key: 'codigoTg', description: 'tg cod.' },
    { keyColumn: 'nomeEvento', key: 'nomeEvento', description: 'Evento' },
    { keyColumn: 'nomeCliente', key: 'nomeCliente', description: 'Cliente' },
    {
      keyColumn: 'consultorComercial',
      key: 'consultorComercial',
      description: 'Consultor Comercial',
    },
    {
      keyColumn: 'nomeConsultor',
      key: 'nomeConsultor',
      description: 'Consultor Cliente',
    },
    { keyColumn: 'origem', key: 'origem', description: 'Origem' },
    { keyColumn: 'destino', key: 'destino', description: 'Destino' },
    { keyColumn: 'dataServico', key: 'dataServico', description: 'Data serviço' },
    {
      keyColumn: 'motivoRecusa',
      key: 'motivoRecusa',
      description: 'Motivo da recusa',
    },
    {
      keyColumn: 'usuarioRecusa',
      key: 'usuarioRecusa',
      description: 'Recusado por',
    },
    { keyColumn: 'dataRecusa', key: 'dataRecusa', description: 'Data recusa' },
  ]

  // Aba SLA (histórico de idas e voltas do Compras)
  pageSla = 1
  rowsSla = 10
  // A API pagina por PROPOSTA, então numberRowsSla conta propostas e não linhas da tabela
  numberRowsSla = 0
  itemsListSla: any[] = []
  loadingSla = false
  exportingSla = false
  slaLoaded = false
  // Resumo do card: média sobre o conjunto filtrado inteiro, não sobre a página
  tempoMedioSla: string | null = null
  rodadasConsideradasSla = 0
  loadingResumoSla = false
  searchFormSla: any = { search: false, model: {} }
  columnsSla: any[] = [
    { keyColumn: 'codigoTg', key: 'codigoTg', description: 'tg cod.' },
    {
      keyColumn: 'custumerPurchase',
      key: 'nomeCliente',
      description: 'Cliente / Subcliente',
    },
    {
      keyColumn: 'nomeConsultor',
      key: 'nomeConsultor',
      description: 'Consultor',
    },
    { keyColumn: 'location_OD', key: 'origem', description: 'Trecho' },
    {
      keyColumn: 'envioFormatado',
      key: 'envioFormatado',
      description: 'Enviado em',
    },
    {
      keyColumn: 'retornoFormatado',
      key: 'retornoFormatado',
      description: 'Retornado em',
    },
    { keyColumn: 'desfecho', key: 'desfecho', description: 'Desfecho' },
    { keyColumn: 'tempoUtil', key: 'tempoUtil', description: 'Tempo útil' },
    {
      keyColumn: 'action',
      key: {
        edit: false,
        delete: false,
        download: false,
        select: true,
        sendContract: false,
        sendEmail: false,
        sendItineraries: false,
      },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    {
      id: 'nomeFantasia',
      description: 'Nome Fantasia',
      type: 'string',
      visible: true,
    },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'inscricaoEstadual',
      description: 'Insc. Estadual',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoMunicipal',
      description: 'Insc. Munucipal',
      type: 'string',
      visible: false,
    },
  ]

  searchForm: any = { search: false, model: {} }
  inputSearch = ''

  ngOnInit() {
    this.createForm()
    this.checkColumnAction()
    // this.getListItems()
    // this.getListSearchStatus()
    // this.listAllRequestStatus()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        delete: this.checkPermission('deletar'),
        download: false,
        select: true,
        sendItineraries: false,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusSelected: [1],
    })
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  //
  // pageChanged(page: number) {
  //   this.page = page
  //   this.uploadList()
  // }
  //
  // uploadList(search: string = '') {
  //   if (search == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     // this.getListItems()
  //     this.getListSearchStatus()
  //   }
  // }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          // tipoServico: item.descricaoTipoServico,
          // servico: item.descricaoServico,
          // tipoVeiculo: item.descricaoTipoVeiculo,
          // tipoMotorista: item.descricaoTipoMotorista,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.purchasesQuoteRequestService
      .listPagedPurchasesQuoteRequestOpen(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  getListSearchStatus() {
    this.loading = true
    const statusId = {
      statusId:
        this.form.get('statusSelected')?.value != ''
          ? this.form.get('statusSelected')?.value
          : 5,
    }
    this.purchasesQuoteRequestService
      .listPagedSearchPurchasesStatus(this.page, this.rows, statusId)
      .subscribe({
        next: (res: any) => {
          if (res.data == null) {
            this.itemsList = []
          } else {
            this.treatResponse(res)
          }
          this.loading = false
        },
        error: (err) => {
          this.itemsList = []
          this.loading = false
        },
      })
  }

  onSelectionStatus(event: MatSelectChange) {
    this.page = 1
    // this.getListSearchStatus(event.value)
    this.uploadList('')
  }

  listAllRequestStatus() {
    this.purchasesQuoteRequestService.PurchaseRequestStatus().subscribe({
      next: (res: any) => {
        this.listStatus = res.data
        this.listStatus.reverse()
      },
      error: (err) => {
        this.listStatus = []
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.purchasesQuoteRequestService
      .searchPagedPurchasesQuoteRequestByProposal(
        // .searchPagedPurchasesQuoteRequest(
        this.page,
        this.rows,
        this.searchForm.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(PurchasesQuoteRequestCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ProposalClientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  downloadItem(item: any) {
    // Implementação do download
  }

  deleteItem(item: any) {
  }

  selectItemEvent(item: any) {
    const dialogRef = this.dialog.open(
      PurchasesQuoteRequestCreateNewComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '100vw',
        width: '100vw',
        maxHeight: '100vh',
        height: '100vh',
        panelClass: 'dialog-fullscreen',
        data: item,
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  viewItinerariesEvent(item: any) {
    const dialogRef = this.dialog.open(
      ModalPurchasesRequestItinerariesComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { item: item },
      },
    )
  }

  // --- Aba Cotações Recusadas ---

  onTabChange(index: number) {
    if (index == 1 && !this.refusedLoaded) {
      this.refusedLoaded = true
      this.getListRefused()
    }
    if (index == 2 && !this.slaLoaded) {
      this.slaLoaded = true
      this.searchListSla()
      this.carregarResumoSla()
    }
  }

  searchRefused(event: any) {
    this.pageRefused = 1
    this.searchFormRefused = event
    this.uploadListRefused()
  }

  pageChangedRefused(event: PageEvent) {
    this.pageRefused = event.pageIndex + 1
    this.rowsRefused = event.pageSize
    this.uploadListRefused()
  }

  uploadListRefused() {
    if (this.searchFormRefused.search) {
      this.searchListRefused()
    } else {
      this.getListRefused()
    }
  }

  treatResponseRefused(response: any) {
    // lista vazia volta como 206 com data null
    this.itemsListRefused = response.data ?? []
    this.numberRowsRefused = response.totalItens ?? 0
  }

  getListRefused() {
    this.loadingRefused = true
    this.purchasesQuoteRequestService
      .listPagedRefusedQuotes(this.pageRefused, this.rowsRefused)
      .subscribe({
        next: (response: any) => {
          this.treatResponseRefused(response)
        },
        error: () => {
          this.itemsListRefused = []
          this.loadingRefused = false
        },
        complete: () => {
          this.loadingRefused = false
        },
      })
  }

  searchListRefused() {
    this.loadingRefused = true
    this.purchasesQuoteRequestService
      .searchPagedRefusedQuotes(
        this.pageRefused,
        this.rowsRefused,
        this.searchFormRefused.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseRefused(response)
        },
        error: () => {
          this.itemsListRefused = []
          this.loadingRefused = false
        },
        complete: () => {
          this.loadingRefused = false
        },
      })
  }

  // O Excel reflete a tela: vai com os mesmos filtros aplicados na busca
  exportRefusedExcel() {
    this.exportingRefused = true
    this.purchasesQuoteRequestService
      .downloadRefusedQuotesExcel(this.searchFormRefused.model)
      .subscribe({
        next: (response: any) => {
          downloadBase64File(
            response.data.fileContent,
            response.data.fileName,
            response.data.type,
          )
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
          this.exportingRefused = false
        },
        complete: () => {
          this.exportingRefused = false
        },
      })
  }

  // --- Aba SLA (histórico de idas e voltas do Compras) ---

  searchSla(event: any) {
    this.pageSla = 1
    this.searchFormSla = event
    this.searchListSla()
    this.carregarResumoSla()
  }

  pageChangedSla(event: PageEvent) {
    this.pageSla = event.pageIndex + 1
    this.rowsSla = event.pageSize
    // o resumo não é refeito: virar página não muda o conjunto filtrado
    this.searchListSla()
  }

  // A API devolve propostas com as rodadas dentro; a tabela é plana, então cada rodada vira
  // uma linha com o cabeçalho da proposta repetido.
  private achatarRodadasSla(propostas: any[]): any[] {
    return propostas.flatMap((proposta: any) =>
      (proposta.itens ?? []).map((rodada: any) => ({
        ...rodada,
        codigoTg: proposta.codigoTg,
        nomeCliente: proposta.nomeCliente,
        nomeSubCliente: proposta.nomeSubCliente,
        nomeEvento: proposta.nomeEvento,
        dataProposta: proposta.dataProposta,
        nomeConsultor: proposta.nomeConsultor,
        envioFormatado: `${rodada.dataEnvio ?? ''} ${rodada.horaEnvio ?? ''}`.trim(),
        retornoFormatado: rodada.dataRetorno
          ? `${rodada.dataRetorno} ${rodada.horaRetorno ?? ''}`.trim()
          : '—',
        // as colunas compostas da table-list-tariff leem estes nomes curtos
        tipoServico: rodada.descricaoTipoServico,
        servico: rodada.descricaoServico,
        tipoVeiculo: rodada.descricaoTipoVeiculo,
        tipoMotorista: rodada.descricaoTipoMotorista,
      })),
    )
  }

  treatResponseSla(response: any) {
    // lista vazia volta como 206 com data null
    this.itemsListSla = this.achatarRodadasSla(response.data ?? [])
    // totalItens conta PROPOSTAS, não rodadas
    this.numberRowsSla = response.totalItens ?? 0
  }

  // Não existe endpoint de listagem sem filtro: body vazio já traz todo o histórico
  searchListSla() {
    this.loadingSla = true
    this.purchasesQuoteRequestService
      .searchPagedComprasHistorico(
        this.pageSla,
        this.rowsSla,
        this.searchFormSla.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseSla(response)
        },
        error: () => {
          this.itemsListSla = []
          this.loadingSla = false
        },
        complete: () => {
          this.loadingSla = false
        },
      })
  }

  // A API não tem endpoint de agregação e pagina por proposta: para a média refletir o filtro
  // inteiro (e não a página), busca tudo de uma vez e calcula aqui. Só roda quando o filtro muda.
  carregarResumoSla() {
    this.loadingResumoSla = true
    this.purchasesQuoteRequestService
      .searchPagedComprasHistorico(1, 9999, this.searchFormSla.model)
      .subscribe({
        next: (response: any) => {
          const rodadas = this.achatarRodadasSla(response.data ?? [])
          const respondidas = rodadas.filter((rodada: any) =>
            DESFECHOS_RESPONDIDOS.includes(rodada.desfecho),
          )

          this.rodadasConsideradasSla = respondidas.length
          this.tempoMedioSla = respondidas.length
            ? secondsToDuration(
                respondidas.reduce(
                  (total: number, rodada: any) =>
                    total + durationToSeconds(rodada.tempoUtil),
                  0,
                ) / respondidas.length,
              )
            : null
        },
        error: () => {
          // melhor mostrar "—" do que segurar a média de outro filtro
          this.tempoMedioSla = null
          this.rodadasConsideradasSla = 0
          this.loadingResumoSla = false
        },
        complete: () => {
          this.loadingResumoSla = false
        },
      })
  }

  // Toda a informação já está na linha: o modal não faz requisição nenhuma
  viewSlaItem(item: any) {
    this.dialog.open(ModalComprasHistoricoDetailComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '900px',
      maxWidth: '900px',
      maxHeight: '620px',
      data: { item: item },
    })
  }

  // O Excel reflete a tela: mesmos filtros, sem paginação
  exportSlaExcel() {
    this.exportingSla = true
    this.purchasesQuoteRequestService
      .downloadComprasHistoricoExcel(this.searchFormSla.model)
      .subscribe({
        next: (response: any) => {
          downloadBase64File(
            response.data.fileContent,
            response.data.fileName,
            response.data.type,
          )
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
          this.exportingSla = false
        },
        complete: () => {
          this.exportingSla = false
        },
      })
  }
}
